import React from 'react';
import PropTypes from 'prop-types';
import { getMessage } from 'util/locale';

import BaseTrigger from 'triggers/BaseTrigger';

const classString = 'vra-save-trigger';
const SaveTrigger = ({
  dataTestId,
  isSaveTriggerEnabled,
  onClickSaveTrigger,
  scriptId
}) => (
  <BaseTrigger
    className={classString}
    content={getMessage('button-text__save')}
    dataTestId={dataTestId}
    disabled={!isSaveTriggerEnabled}
    handler={() => onClickSaveTrigger(scriptId)}
    mode='primary'
  />
);
SaveTrigger.propTypes = {
  dataTestId: PropTypes.string,
  isSaveTriggerEnabled: PropTypes.bool.isRequired,
  onClickSaveTrigger: PropTypes.func.isRequired,
  scriptId: PropTypes.string.isRequired
};
export default SaveTrigger;
